const u = navigator.userAgent;

// 系统类型判断
export const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
export const isHarmony = u.toLowerCase().indexOf('harmonyos') > -1;
export const isAndroid = !isHarmony && !isIos && u.toLowerCase().indexOf('android') > -1 || u.indexOf('adr') > -1;
export const isChromeBrowser = u.indexOf('WebKit') > -1;
